import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import stickybits from 'stickybits';

export interface ISticky {
  scrollEl: string;
}

@Directive({
  selector: '[i2gSticky]',
})
export class StickyDirective implements OnChanges, OnDestroy {
  @Input() sticky: any;

  private _stickyBitsInstance: any;

  constructor(private _elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.sticky) {
      this.cleanup();

      if (this.sticky) {
        this._stickyBitsInstance = stickybits(this._elementRef.nativeElement, {
          scrollEl: this.sticky.scrollEl,
        });
      }
    }
  }

  cleanup() {
    if (this._stickyBitsInstance) {
      this._stickyBitsInstance.cleanup();
    }
  }

  ngOnDestroy() {
    this.cleanup();
  }
}
